<template>
	<section class="main-content promo-section">
		<div class="row promoblocks-header">
			<slot name="header" />
		</div>
		<div class="row promoblocks align-center">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column6">
				<nuxt-link :to="localePath(`/${block.link}`)">
					<picture>
						<source :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
					</picture>
				</nuxt-link>
				<div class="content">
					<h3>
						<nuxt-link :to="localePath(`/${block.link}`)">
							{{ block.header }}
						</nuxt-link>
					</h3>
					<div v-parse-links v-html="block.content" />
					<nuxt-link :to="localePath(`/${block.link}`)" class="button button-no-fill">
						{{ block.button }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.promo-section {
	background: url('~/assets/images/promoblocks-bg-pattern.jpg') no-repeat center center;
	background-size: cover;
}

.promoblocks {
	margin: 25px auto 50px;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;

	.column6 {
		display: flex;
		flex-flow: column;

		.content {
			flex: 1;
			padding: 75px 50px 125px;
			position: relative;
			margin: 15px 0 0;
			background: none;
			border: 1px solid var(--primary-color);
			color: var(--body-color);

			.button,
			.button-arrow {
				position: absolute;
				bottom: 75px;
				left: 50px;
			}
		}
	}

	h2,
	h3 {
		color: var(--header-color);
	}

	p {
		color: var(--primary-text-color);
	}
}

.promoblocks-header {
	h2,
	:deep(h2) {
		max-width: 360px;
	}
}

@media (max-width: 960px) {
	.promoblocks {
		.column6 {
			margin: 25px 0 50px;

			.content {
				padding: 40px 40px 90px;

				.button {
					bottom: 40px;
					left: 40px;
				}
			}
		}
	}
}
</style>
